/* eslint-disable */

export default function giftCardValidation() {
  // Set up form submission validation
  const productForms = document.querySelectorAll('.gift-card form[is="product-form"]');
  if (productForms.length === 0) {
    return;
  }
  
  productForms.forEach(form => {
    form.addEventListener('submit', function(event) {
      if (!validateGiftCardForm()) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    });
  });

  // Set up real-time validation on input changes
  const recipientForm = document.querySelector('recipient-form');
  const checkbox = recipientForm?.querySelector('input[type="checkbox"]');
  if (recipientForm) {
    const inputs = recipientForm.querySelectorAll('input, textarea');
    
    // If checkbox exists, hide it but keep it checked
    if (checkbox) {
      checkbox.checked = true;
      checkbox.style.display = 'none';
      
      // Hide the label too
      const label = recipientForm.querySelector('label[for="' + checkbox.id + '"]');
      if (label) {
        label.style.display = 'none';
      }
    }
    
    inputs.forEach(input => {
      input.addEventListener('blur', () => {
        validateGiftCardForm();
      });
      input.addEventListener('input', () => {
        clearFieldError(input);
      });
    });
  }
}

function validateGiftCardForm() {
  const recipientForm = document.querySelector('recipient-form');
  if (!recipientForm) return true;

  const checkbox = recipientForm.querySelector('input[type="checkbox"]');
  // If checkbox exists but is hidden, treat as always checked
  if (checkbox && checkbox.style.display === 'none') {
    // Checkbox is hidden, so always validate
  } else if (checkbox && !checkbox.checked) {
    return true; // Form not enabled, allow add to cart
  }

  // Get form elements
  const emailInput = recipientForm.querySelector('input[type="email"]');
  const nameInput = recipientForm.querySelector('input[autocomplete="name"]');
  const messageInput = recipientForm.querySelector('textarea')
  
  const errors = [];
  let isValid = true;

  // Email validation (mandatory)
  if (!emailInput.value.trim()) {
    errors.push('Email is required');
    showFieldError(emailInput, 'Email is required');
    isValid = false;
  } else if (!isValidEmail(emailInput.value)) {
    errors.push('Please enter a valid email address');
    showFieldError(emailInput, 'Please enter a valid email address');
    isValid = false;
  } else {
    clearFieldError(emailInput);
  }

  // Name validation (optional)
  clearFieldError(nameInput);

  // Message validation (optional but if provided, check length)
  if (messageInput.value.trim()) {
    const maxLength = parseInt(messageInput.getAttribute('maxlength')) || 200;
    if (messageInput.value.length > maxLength) {
      errors.push(`Message must be ${maxLength} characters or less`);
      showFieldError(messageInput, `Message must be ${maxLength} characters or less`);
      isValid = false;
    } else {
      clearFieldError(messageInput);
    }
  }

  // Show/hide main error message
  const errorWrapper = recipientForm.querySelector('.product-form__recipient-error-message-wrapper');
  if (!isValid && errors.length > 0) {
    showMainError(errorWrapper, errors);
    // Scroll to error message
    errorWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
  } else {
    hideMainError(errorWrapper);
  }

  // Disable/enable add to cart button based on validation
  toggleAddToCartButton(!isValid);

  return isValid;
}

function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

function showFieldError(input, message) {
  const fieldContainer = input.closest('.form-field');
  const errorElement = fieldContainer?.querySelector('.form__message--error');
  if (errorElement) {
    const errorText = errorElement.querySelector('.error-message');
    if (errorText) {
      errorText.textContent = message;
    }
    errorElement.classList.remove('hidden');
    input.setAttribute('aria-invalid', 'true');
    input.setAttribute('aria-describedby', errorElement.id);
  }
}

function clearFieldError(input) {
  const fieldContainer = input.closest('.form-field');
  const errorElement = fieldContainer?.querySelector('.form__message--error');
  
  if (errorElement) {
    errorElement.classList.add('hidden');
    const errorText = errorElement.querySelector('.error-message');
    if (errorText) {
      errorText.textContent = '';
    }
    input.removeAttribute('aria-invalid');
    input.removeAttribute('aria-describedby');
  }
}

function showMainError(errorWrapper, errors) {
  if (!errorWrapper) return;
  
  errorWrapper.hidden = false;
  const errorList = errorWrapper?.querySelector('ul');
  if (errorList) {
    errorList.innerHTML = '';
    errors.forEach(error => {
      const li = document.createElement('li');
      li.textContent = error;
      li.className = 'error-message';
      errorList.appendChild(li);
    });
  }
}

function hideMainError(errorWrapper) {
  if (!errorWrapper) return;
  errorWrapper.hidden = true;
  const errorList = errorWrapper?.querySelector('ul');
  if (errorList) {
    errorList.innerHTML = '';
  }
}

function toggleAddToCartButton(hasErrors) {
  const addToCartButtons = document.querySelectorAll('.product-form__submit');
  addToCartButtons.forEach(button => {
    if (hasErrors) {
      button.setAttribute('aria-disabled', 'true');
      button.disabled = true;
      button.classList.add('btn--disabled');
    } else {
      button.removeAttribute('aria-disabled');
      button.disabled = false;
      button.classList.remove('btn--disabled');
    }
  });
}